<template>
    <div v-if="project.resolution_date === null && project.status > 4" style="margin-top: 10px;">
        En Fondeo<br>
        {{showPercentage(project.funded, project.finance.financed_amount)}}% |
        <span title="Suma TRX I22% - I150">{{project.funded|currency}}</span>
        de {{project.finance.financed_amount|currency}}
        <div class="progress">
            <div
                class="progress-bar bg-success"
                role="progressbar"
                :style="'width: ' + showPercentage(project.funded, project.finance.financed_amount) + '%'"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"></div>
        </div>
    </div>

</template>

<script>

    export default {
        name: "ProjectFundingProgress",
        props: {
            project: {
                type: Object,
                required: true,
                default: {}
            }
        },
        methods: {
            showPercentage(funded, financed_amount) {
                return ((funded / financed_amount) * 100).toFixed(0)
            },
        }
    }
</script>

<style scoped>

</style>
